import React from 'react'
import styles from './styles.module.scss'

const Testimony = ({ content, author, designation, img }) => {
  return (
    <div>
      <div className={styles.testimony}>
        <div>
          {content}
          <div>
            <h4>{author}</h4>
            <p>{designation}</p>
          </div>
        </div>
        <img src={img} alt="student" height="50" width="75" />
      </div>
    </div>
  )
}

export default Testimony
